import React from 'react';
import store from '../store';
import FloatButton from '../components/FloatButton';
//import CardContent from '../components/CardContent';
import Toolbar from '../components/Toolbar';
import DialogCourse from '../components/DialogCourse';
import CardPracticeGuest from '../components/CardPracticeGuest';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import  FormControl  from '@material-ui/core/FormControl';
import Button  from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import GroupWorkIcon from '@material-ui/icons/Group';
import ReceiptIcon from '@material-ui/icons/Receipt';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import { Redirect } from 'react-router-dom';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AddIcon from '@material-ui/icons/Add';
const DWIDTH = 640;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
const styles = theme => ({
    title: {
        marginBottom: theme.spacing.unit * 2,
        padding: 0
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    },
    buttonAdd: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}


class AdminGuest extends React.Component {
    constructor() {
        super();
        this.state = { search: '',contents:[],open:false,practice:false};

    }
    loadContents(){
      console.log('load Contents');
      let _this = this;
      let sub = firebase.firestore().collection('courses').orderBy('created','desc').onSnapshot((data)=>{
        let contents = [];
        data.forEach((doc)=>{
          let item = doc.data();
          item.id=doc.id;
          contents.push(item);
        })

        _this.setState({contents});
      })
      _this.setState({sub});
    }
    loadPracticeGuest(){

      let _this = this;
      firebase.firestore().collection('guest').doc('practice').get().then((doc)=>{
        let practice = doc.data();


        _this.setState({practice});
      })
    }
    componentDidMount(){
      //this.loadContents();
      this.loadPracticeGuest();
    }
    componentWillUnmount(){
      if(this.state.sub)
      this.state.sub();
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    handleClose = value => {
        this.setState({ open: false });
    };
    handleClickOpen = () => {
            this.setState({
                open: true,
            });
        };



    render() {
        const { classes } = this.props;
        const { search,contents } = this.state;

        const item_button =  { name:"", startDate: '',endDate:'',week:4,course_id:0,created:(new Date()).getTime() };
        if(!store.getState().ADMINACCOUNT)
        {
          console.log('No Admin');
          return <Redirect to='/sbadmin' />
        }
        return (
          <div>
          <Toolbar/>
            <div style={{ maxWidth: '720px',margin: '20px auto',paddingTop: '64px'}}>
                <Grid justify="flex-start" direction="row" container>
                    <Grid item><AllInboxIcon style={{ marginRight: 10 }} /></Grid>
                    <Grid item><Typography variant="title" className={classes.title}>Guest</Typography></Grid>
                </Grid>
                {this.state.practice?
                    <CardPracticeGuest item={this.state.practice} reload={()=>this.loadPracticeGuest()} />
                :false}


                <FormControl style={{ marginBottom: 30 }} fullWidth>
                    <Input
                        value={this.state.search}
                        onChange={this.handleChange('search')}
                        type="text"
                        placeholder="Search a course"
                        className={classes.search}
                    />
                </FormControl>

                <div style={{ height: 100, display: 'block' }} />

                </div>

            </div>
        )
    }
}

AdminGuest.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminGuest);
